import { render, staticRenderFns } from "./card-text.svg.vue?vue&type=template&id=1feec88e&"
import script from "./card-text.svg.vue?vue&type=script&lang=js&"
export * from "./card-text.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports